import { inject } from '@angular/core';
import { Route } from '@angular/router';
import { EntitlementsService } from 'entitlements';
// import { IntentSurgesV2Component } from '@features/intent-navigator-v2'; // Removed due to lazy loading requirement

export const centralRoutes: Route[] = [
  // Empty path redirect is handled by redirectIfNoPath() in central-main-layout.component.ts
  // {
  //   path: '',
  //   redirectTo: 'demand',
  //   pathMatch: 'full',
  // },
  {
    path: 'demand',
    canActivate: [
      () =>
        inject(EntitlementsService).canActivateWithPermissions({
          requireHubReportsAccess: 'app.central.demand',
        }),
    ],
    loadChildren: () =>
      import('@features/lead-intelligence').then(
        (m) => m.LeadIntelligenceModule,
      ),
  },
  {
    path: 'advertising',
    canActivate: [
      () =>
        inject(EntitlementsService).canActivateWithPermissions({
          requireHubReportsAccess: 'app.central.advertising',
        }),
    ],
    loadChildren: () =>
      import('advertising-overview').then((m) => m.AdvertisingOverviewRoutes),
  },
  {
    path: 'intent',
    canActivate: [
      () =>
        inject(EntitlementsService).canActivateWithPermissions({
          requireHubReportsAccess: 'app.central.intent',
        }),
    ],
    loadChildren: () =>
      import('@features/intent-navigator-v2').then(
        (m) => m.IntentNavigatorV2Module,
      ),
  },
  {
    path: 'engagement-funnel',
    canActivate: [
      () =>
        inject(EntitlementsService).canActivateWithPermissions({
          requireHubReportsAccess: 'app.measurementStudio.accountFunnel',
          requireNotLimitedView: false,
          id: 'account-funnel-measure-studio',
        }),
    ],
    loadChildren: () =>
      import('@features/engagement-funnel-v2').then(
        (m) => m.EngagementFunnelV2Module,
      ),
  },
  // {
  //   path: 'data-unification',
  //   component: DataUnificationContainerComponent,
  //   canActivate: [
  //     () =>
  //       inject(EntitlementsService).canActivateWithPermissions({
  //         requireMyTAdmin: true,
  //         id: 'adex-admin',
  //       }),
  //   ],
  //   children: [
  //     {
  //       path: 'contact-2-5',
  //       component: DataUnificationContactsComponent,
  //     },
  //     {
  //       path: 'contacts-hems',
  //       component: DataUnificationComponent,
  //     },
  //     {
  //       path: 'technologies',
  //       component: DataUnificationComponent,
  //     },
  //     {
  //       path: 'technology-detection',
  //       component: DataUnificationComponent,
  //     },
  //     {
  //       path: 'data-overview',
  //       component: DataOverviewComponent,
  //     },
  //     {
  //       path: 'financial-events',
  //       component: DataUnificationComponent,
  //     },
  //     {
  //       path: 'news-events',
  //       component: DataUnificationComponent,
  //     },
  //     {
  //       path: 'job-openings',
  //       component: DataUnificationComponent,
  //     },
  //     {
  //       path: 'companies',
  //       children: [
  //         {
  //           path: '',
  //           pathMatch: 'full',
  //           component: DataUnificationCompaniesComponent,
  //         },
  //         {
  //           path: ':company_id',
  //           component: DataUnificationCompanyComponent,
  //         },
  //       ],
  //     },
  //   ],
  // },
];
